import Vue from 'vue'
import Router from 'vue-router'

import VueAuth from '@websanova/vue-auth'

import store from './store/store'

// Routes
import routes from "@/routes/routes";
import dashboard_routes from "@/routes/dashboard_routes";
import product_routes from "@/routes/product_routes";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: 'exact-active',
    routes: [
        ...routes,
        ...dashboard_routes,
        ...product_routes,
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else if (
            to.name == 'social-studies' || to.name == 'science' || to.name =='summer-school' &&
            to.name == from.name
        ) {
            // product page. do not scroll to top of page
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

router.beforeEach((to, from, next) => {
    if (to.hash === '#homeschool') {
        store.dispatch("setAsHomeschoolStore", true);
    }

    if (to.hash === '#school') {
        store.dispatch("setAsHomeschoolStore", false);
    }

    if (to.matched.some(record => record.meta.title)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        document.title = to.meta.title
        next()
        return;
    }

    next();

})

export default router;
